// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: auto;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
}

/* Header */
.login-header {
  padding: 20px 40px;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  width: 40px;
  height: 40px;
  background: #4a90e2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.logo-icon svg {
  width: 24px;
  height: 24px;
  stroke-width: 2;
}

.logo-text {
  font-size: 28px;
  font-weight: 700;
  color: #4a90e2;
  letter-spacing: -0.5px;
}

/* Main Content */
.login-content {
  flex: 1 1;
  display: flex;
  min-height: calc(100vh - 220px);
  margin: 2rem;
}

.login-background {
  flex: 1 1;
  position: relative;
  overflow: hidden;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Login Panel */
.login-panel {
  width: 400px;
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 50%, #2e5f8a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
}

.login-form-container {
  width: 100%;
  max-width: 320px;
}

.login-title {
  color: white;
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 40px 0;
  text-align: center;
}

/* Form Styles */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-input {
  padding: 15px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.95);
  color: #333;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-input:focus {
  outline: none;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.form-input.error {
  border: 2px solid #ff6b6b;
  background: #fff5f5;
}

.form-input::placeholder {
  color: #999;
  font-weight: 400;
}

.form-input:disabled {
  background: rgba(255, 255, 255, 0.7);
  cursor: not-allowed;
}

/* Error Messages */
.field-error {
  color: #ffcccb;
  font-size: 13px;
  font-weight: 500;
  margin-top: 4px;
}

.general-error {
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.3);
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  color: #ffcccb;
  font-size: 14px;
  text-align: center;
}

/* Forgot Password */
.forgot-password-section {
  display: flex;
  justify-content: flex-end;
  margin-top: -8px;
}

.forgot-password-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s ease;
}

.forgot-password-link:hover {
  color: white;
  text-decoration: underline;
}

/* Login Button */
.login-button {
  background: #1e3a5f;
  color: white;
  border: none;
  padding: 16px 20px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 52px;
  margin-top: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.login-button:hover:not(:disabled) {
  background: #2a4a6b;
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled,
.login-button.disabled {
  background: rgba(30, 58, 95, 0.6);
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Divider */
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 30px 0 20px 0;
}

.divider span {
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  font-weight: 300;
}

.divider-line {
  flex: 1 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
}

/* Register Section */
.register-section {
  text-align: center;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  line-height: 1.5;
}

.register-link {
  color: white;
  text-decoration: underline;
  font-weight: 600;
  transition: opacity 0.2s ease;
}

.register-link:hover {
  opacity: 0.8;
}

/* Footer */
.login-footer {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 50%, #2e5f8a 100%);
  padding: 30px 40px;
  color: white;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
}

/* .footer-left {
  flex: 1;
} */

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.footer-logo-icon {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.footer-logo-icon svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

.footer-logo-text {
  font-size: 24px;
  font-weight: 700;
  color: white;
}

.footer-text p {
  margin: 0 0 8px 0;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.9);
  max-width: 500px;
}

.footer-right {
  flex-shrink: 0;
  margin-left: 40px;
}

.contact-info h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 700;
  color: white;
  letter-spacing: 0.5px;
}

.contact-details p {
  margin: 0 0 5px 0;
  font-size: 14px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.9);
}

.contact-details p:first-child {
  font-weight: 600;
  margin-bottom: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .login-content {
    flex-direction: column;
  }

  .login-background {
    height: 200px;
  }

  .login-panel {
    width: 100%;
    min-height: calc(100vh - 320px);
    padding: 30px 20px;
  }

  .login-header {
    padding: 15px 20px;
  }

  .logo-text {
    font-size: 24px;
  }

  .footer-content {
    flex-direction: column;
    gap: 30px;
  }

  .footer-right {
    margin-left: 0;
  }
}

@media (max-width: 480px) {
  .login-panel {
    padding: 20px 15px;
  }

  .login-form-container {
    max-width: 100%;
  }

  .login-title {
    font-size: 28px;
    margin-bottom: 30px;
  }

  .form-input {
    font-size: 16px; /* Prevents zoom on iOS */
    padding: 12px 16px;
  }

  .login-header {
    padding: 10px 15px;
  }

  .login-footer {
    padding: 20px 15px;
  }
}

/* Focus Styles for Accessibility */
.form-input:focus-visible,
.login-button:focus-visible,
.forgot-password-link:focus-visible,
.register-link:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.8);
  outline-offset: 2px;
}

/* High Contrast Mode Support */
@media (prefers-contrast: high) {
  .form-input {
    border: 2px solid transparent;
  }

  .form-input:focus {
    border-color: #4a90e2;
  }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,WAAW;EACX,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA,WAAW;AACX;EACE,0EAA0E;EAC1E,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe,EAAE,yBAAyB;IAC1C,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,mCAAmC;AACnC;;;;EAIE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF","sourcesContent":[".login-page {\n  min-height: auto;\n  display: flex;\n  flex-direction: column;\n  background: #f5f5f5;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", sans-serif;\n}\n\n/* Header */\n.login-header {\n  padding: 20px 40px;\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.logo-icon {\n  width: 40px;\n  height: 40px;\n  background: #4a90e2;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.logo-icon svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 2;\n}\n\n.logo-text {\n  font-size: 28px;\n  font-weight: 700;\n  color: #4a90e2;\n  letter-spacing: -0.5px;\n}\n\n/* Main Content */\n.login-content {\n  flex: 1;\n  display: flex;\n  min-height: calc(100vh - 220px);\n  margin: 2rem;\n}\n\n.login-background {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n}\n\n.background-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Login Panel */\n.login-panel {\n  width: 400px;\n  background: linear-gradient(135deg, #4a90e2 0%, #357abd 50%, #2e5f8a 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  position: relative;\n}\n\n.login-form-container {\n  width: 100%;\n  max-width: 320px;\n}\n\n.login-title {\n  color: white;\n  font-size: 32px;\n  font-weight: 600;\n  margin: 0 0 40px 0;\n  text-align: center;\n}\n\n/* Form Styles */\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-input {\n  padding: 15px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  background: rgba(255, 255, 255, 0.95);\n  color: #333;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.form-input:focus {\n  outline: none;\n  background: white;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.form-input.error {\n  border: 2px solid #ff6b6b;\n  background: #fff5f5;\n}\n\n.form-input::placeholder {\n  color: #999;\n  font-weight: 400;\n}\n\n.form-input:disabled {\n  background: rgba(255, 255, 255, 0.7);\n  cursor: not-allowed;\n}\n\n/* Error Messages */\n.field-error {\n  color: #ffcccb;\n  font-size: 13px;\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n.general-error {\n  background: rgba(255, 107, 107, 0.1);\n  border: 1px solid rgba(255, 107, 107, 0.3);\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 16px;\n  color: #ffcccb;\n  font-size: 14px;\n  text-align: center;\n}\n\n/* Forgot Password */\n.forgot-password-section {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: -8px;\n}\n\n.forgot-password-link {\n  color: rgba(255, 255, 255, 0.9);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.forgot-password-link:hover {\n  color: white;\n  text-decoration: underline;\n}\n\n/* Login Button */\n.login-button {\n  background: #1e3a5f;\n  color: white;\n  border: none;\n  padding: 16px 20px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 52px;\n  margin-top: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.login-button:hover:not(:disabled) {\n  background: #2a4a6b;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-button:disabled,\n.login-button.disabled {\n  background: rgba(30, 58, 95, 0.6);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Divider */\n.divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  margin: 30px 0 20px 0;\n}\n\n.divider span {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 16px;\n  font-weight: 300;\n}\n\n.divider-line {\n  flex: 1;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* Register Section */\n.register-section {\n  text-align: center;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.register-link {\n  color: white;\n  text-decoration: underline;\n  font-weight: 600;\n  transition: opacity 0.2s ease;\n}\n\n.register-link:hover {\n  opacity: 0.8;\n}\n\n/* Footer */\n.login-footer {\n  background: linear-gradient(135deg, #4a90e2 0%, #357abd 50%, #2e5f8a 100%);\n  padding: 30px 40px;\n  color: white;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* .footer-left {\n  flex: 1;\n} */\n\n.footer-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.footer-logo-icon {\n  width: 32px;\n  height: 32px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.footer-logo-icon svg {\n  width: 18px;\n  height: 18px;\n  stroke-width: 2;\n}\n\n.footer-logo-text {\n  font-size: 24px;\n  font-weight: 700;\n  color: white;\n}\n\n.footer-text p {\n  margin: 0 0 8px 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 500px;\n}\n\n.footer-right {\n  flex-shrink: 0;\n  margin-left: 40px;\n}\n\n.contact-info h3 {\n  margin: 0 0 15px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: white;\n  letter-spacing: 0.5px;\n}\n\n.contact-details p {\n  margin: 0 0 5px 0;\n  font-size: 14px;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.contact-details p:first-child {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .login-content {\n    flex-direction: column;\n  }\n\n  .login-background {\n    height: 200px;\n  }\n\n  .login-panel {\n    width: 100%;\n    min-height: calc(100vh - 320px);\n    padding: 30px 20px;\n  }\n\n  .login-header {\n    padding: 15px 20px;\n  }\n\n  .logo-text {\n    font-size: 24px;\n  }\n\n  .footer-content {\n    flex-direction: column;\n    gap: 30px;\n  }\n\n  .footer-right {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-panel {\n    padding: 20px 15px;\n  }\n\n  .login-form-container {\n    max-width: 100%;\n  }\n\n  .login-title {\n    font-size: 28px;\n    margin-bottom: 30px;\n  }\n\n  .form-input {\n    font-size: 16px; /* Prevents zoom on iOS */\n    padding: 12px 16px;\n  }\n\n  .login-header {\n    padding: 10px 15px;\n  }\n\n  .login-footer {\n    padding: 20px 15px;\n  }\n}\n\n/* Focus Styles for Accessibility */\n.form-input:focus-visible,\n.login-button:focus-visible,\n.forgot-password-link:focus-visible,\n.register-link:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.8);\n  outline-offset: 2px;\n}\n\n/* High Contrast Mode Support */\n@media (prefers-contrast: high) {\n  .form-input {\n    border: 2px solid transparent;\n  }\n\n  .form-input:focus {\n    border-color: #4a90e2;\n  }\n}\n\n/* Reduced Motion Support */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
